// Função assíncrona para obter o IP do usuário
export default async function getUserIP() {
    try {
      // Faz uma solicitação para um serviço de terceiros que retorna o IP do usuário
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      
      // Retorna o IP do usuário obtido da resposta
      return data.ip;
    } catch (error) {
      // Em caso de erro, retorna um valor padrão ou lida com o erro de acordo com os requisitos do seu aplicativo
      console.error('Erro ao obter o IP do usuário:', error);
      return '0.0.0.0'; // IP padrão ou outra lógica de tratamento de erro
    }
  }